import type { ComputedRef } from 'vue';
import { TypedSchema } from 'vee-validate';

export interface InputOptions {
  value: any;
  label: string;
  selected?: boolean;
}

export enum InputType {
  Text = 'text',
  TextArea = 'textarea',
  Search = 'search',
  Select = 'select',
  MultiSelect = 'multiselect',
  File = 'file',
  Password = 'password',
  Number = 'number',
  Radio = 'radio',
  Checkbox = 'checkbox',
  ButtonGroup = 'button-group',
  Date = 'date',
  DateTime = 'datetime-local',
  DateRange = 'date-range',
  Time = 'time',
  Email = 'email',
  Hidden = 'hidden',
  Range = 'range',
  Tel = 'tel',
  URL = 'url',
}

export interface BaseInputField {
  disabled?: boolean;
  label?: string;
  value?: string | boolean | any[] | number;
  type: InputType;
  rules?: TypedSchema | ComputedRef<TypedSchema>;
  options?: ComputedRef<InputOptions[]> | InputOptions[];
  name: string;
  mime?: string;
  maxlength?: number;
  notes?: string[];
  required?: boolean;
  pickerType?: string;
}

export interface InputField extends BaseInputField {
  label: string;
  showPasswordToggle?: boolean;
}
